<template lang="pug">
  .upload-proposal-and-quotation.grid-content
    el-row(:gutter="20").m-15
      el-col.text-right.required(:span="4") {{ $t('方案 & 报价') }}
      el-col(:span="10")
        el-upload(
          :action="$t('组件必传项，无意义')"
          :http-request="upload"
          :show-file-list="false"
        )
          el-button(
            type="primary",
          ) {{ $t('点击上传') }}
        span {{ $t(fileName) }}
</template>

<script>

export default {
  data () {
    return {
      fileName: '未上传文件'
    }
  },
  methods: {
    upload (inst) {
      this.fileName = inst.file.name
      this.$emit('upload', inst.file)
    }
  }
}
</script>

<style lang="stylus">
.upload-proposal-and-quotation
  .el-row > .el-col:nth-child(2)
    display flex
    align-items center
    margin-right 10px
    > span
      margin-left 10px

</style>
